// Footer.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Menu,
  MenuItem,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { MoreVert as MoreVertIcon } from "@material-ui/icons";
import { getFooterActions } from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-start",
  },
  dropdownButton: {
    background: "linear-gradient(90deg, #0A2D71 0%, #133984 100%)",
    color: "#fff",
  },
}));

const Footer = ({
  onSaveAsDraft,
  onSubmit,
  onApproveOrReject,
  handleOpenModal,
  sendBackToRTA,
  ticketStatus,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingAction, setLoadingAction] = useState(null);
  const { roles } = useSelector((state) => state.auth.user);
  const commonActions = getFooterActions(roles, ticketStatus);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

const handleAction = async (action) => {
  if (action !== "reject") setLoadingAction(action);
  handleCloseMenu();

  try {
    if (action === "save_and_approve") {
      await onSaveAsDraft();
      await onApproveOrReject("approve");
      return;
    }

    switch (action) {
      case "save":
        await onSaveAsDraft();
        break;
      case "submit":
        await onSubmit();
        break;
      case "approve":
        await onApproveOrReject("approve");
        break;
      case "reject":
        handleOpenModal();
        break;
      case "send_back_to_rta":
        await sendBackToRTA();
        break;
      default:
        break;
    }
  } catch (error) {
    console.error("Action failed:", error);
  } finally {
    if (action !== "reject") setLoadingAction(null);
  }
};


  return (
    <div className={classes.footer}>
      {loadingAction ? (
        <Button variant="contained" className={classes.dropdownButton} disabled>
          <CircularProgress size={24} style={{ color: "#fff" }} />
        </Button>
      ) : (
        commonActions.length !== 0 && (
          <Button
            variant="contained"
            className={classes.dropdownButton}
            onClick={handleOpenMenu}
            endIcon={<MoreVertIcon />}
          >
            Actions
          </Button>
        )
      )}

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        {commonActions.map(({ label, icon, action }) => (
          <MenuItem key={action} onClick={() => handleAction(action)}>
            {icon}
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

Footer.propTypes = {
  onSaveAsDraft: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onApproveOrReject: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  sendBackToRTA: PropTypes.func.isRequired,
  ticketStatus: PropTypes.string.isRequired,
};

export default Footer;
